export const isNonTransactional = false

export const showPriceshowPriceTransactional = true